document.addEventListener("DOMContentLoaded", function () {
    // Function to get the value of a cookie by its name
    function getCookie(name) {
      let nameEQ = name + "=";
      let cookiesArray = document.cookie.split(";");
      for (let i = 0; i < cookiesArray.length; i++) {
        let cookie = cookiesArray[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
          return decodeURIComponent(cookie.substring(nameEQ.length));
        }
      }
      return null;
    }
    const userPreference = getCookie("userPreference");
    console.log(userPreference);
    if (userPreference) {
      return false;
    }
  
    const popup = document.getElementById("age-verification-popup");
    const body = document.body;
    popup.style.display = "flex";
    body.classList.add("no-scroll");
  
    const overlay = document.createElement("div");
    overlay.id = "overlay";
    document.body.appendChild(overlay);
  
    function showPopup() {
      popup.style.display = "flex";
      overlay.style.display = "block";
      document.body.style.overflow = "hidden";
    }
  
    function hidePopup() {
      popup.style.display = "none";
      overlay.style.display = "none";
      document.body.style.overflow = "auto";
    }
    showPopup();
  
    function validateNumberInput(input, min, max, nextInput) {
      input.addEventListener("input", function () {
        let value = parseInt(this.value, 10);
  
        if (this.id.startsWith("year") && this.value.length > 4) {
          this.value = this.value.slice(0, 4);
        }
  
        if (value < min || value > max || isNaN(value)) {
          this.value = "";
          this.style.borderColor = "red";
        } else {
          this.style.borderColor = "";
          if (nextInput) {
            nextInput.focus(); // Focus next input field if valid
          }
        }
      });
    }
  
    // Apply validation to each input field and go to the next field if valid
    validateNumberInput(
      document.getElementById("day1"),
      0,
      3,
      document.getElementById("day2")
    );
    validateNumberInput(
      document.getElementById("day2"),
      0,
      9,
      document.getElementById("month1")
    );
    validateNumberInput(
      document.getElementById("month1"),
      0,
      1,
      document.getElementById("month2")
    );
    validateNumberInput(
      document.getElementById("month2"),
      0,
      9,
      document.getElementById("year1")
    );
    validateNumberInput(
      document.getElementById("year1"),
      0,
      9,
      document.getElementById("year2")
    );
    validateNumberInput(document.getElementById("year2"), 0, 9, null);
  
    // Special validation for full day and month when both digits are entered
    function validateFullDate() {
      let day1 = document.getElementById("day1").value;
      let day2 = document.getElementById("day2").value;
      let month1 = document.getElementById("month1").value;
      let month2 = document.getElementById("month2").value;
  
      if (day1 && day2) {
        let fullDay = parseInt(day1 + day2, 10);
        if (fullDay < 1 || fullDay > 31) {
          document.getElementById("day1").value = "";
          document.getElementById("day2").value = "";
        }
      }
  
      if (month1 && month2) {
        let fullMonth = parseInt(month1 + month2, 10);
        if (fullMonth < 1 || fullMonth > 12) {
          document.getElementById("month1").value = "";
          document.getElementById("month2").value = "";
        }
      }
    }
  
    // Attach validation to the second input of day and month
    document.getElementById("day2").addEventListener("input", validateFullDate);
    document.getElementById("month2").addEventListener("input", validateFullDate);
  
    // Handle form submission (Age verification and country selection)
    function fullvalidation() {
      const day1 = document.getElementById("day1").value;
        const day2 = document.getElementById("day2").value;
        const month1 = document.getElementById("month1").value;
        const month2 = document.getElementById("month2").value;
        const year1 = document.getElementById("year1").value;
        const year2 = document.getElementById("year2").value;
        if (!day1 || !day2 || !month1 || !month2 || !year1 || !year2) {
          return
        }
        // Reset error messages and input borders
        const errorMessages = document.querySelectorAll(".error-message");
        errorMessages.forEach((error) => (error.textContent = ""));
        const dateInputs = document.querySelectorAll(".date-input");
        dateInputs.forEach((input) => (input.style.borderColor = "#000"));
  
        // Validate if all fields are filled
        if (!day1 || !day2 || !month1 || !month2 || !year1 || !year2) {
          const errorMessage = document.getElementById("error-message");
          dateInputs.forEach((input) => (input.style.borderColor = "red"));
          errorMessage.textContent = "Please fill the date first.";
          errorMessage.style.display = "block";
          return false;
        }
  
        // Combine day, month, and year into a single value
        const day = parseInt(day1 + day2);
        const month = parseInt(month1 + month2);
        let year = parseInt(year1 + year2);
  
        let invalidInput = false;
  
        // Validate day (should be between 01 and 31)
        if (day < 1 || day > 31) {
          const dayError = document.getElementById("day-error");
          dayError.textContent = "Invalid day. Day should be between 01 and 31.";
          invalidInput = true;
        }
  
        // Validate month (should be between 01 and 12)
        if (month < 1 || month > 12) {
          const monthError = document.getElementById("month-error");
          monthError.textContent =
            "Invalid month. Month should be between 01 and 12.";
          invalidInput = true;
        }
  
        if (year >= 0 && year <= 25) {
          year += 2000;
        } else if (year >= 26 && year <= 99) {
          year += 1900;
        }
  
        // If any field is invalid, stop the form submission
        if (invalidInput) {
          dateInputs.forEach((input) => {
            if (!input.value || input.style.borderColor === "red") {
              input.style.borderColor = "red";
            }
          });
          return false;
        }
  
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        const currentDay = currentDate.getDate();
  
        let age = currentYear - year;
        if (
          currentMonth < month ||
          (currentMonth === month && currentDay < day)
        ) {
          age--;
        }
        // Get elements
        const countryInput = document.getElementById("country-input");
        let country_age = countryInput.getAttribute("data-age");
        if(country_age == 0){
          countryInput.style.borderColor = "red";
          const errorMessage = document.getElementById("error-message");
          errorMessage.textContent = "Please select country";
          errorMessage.style.display = "block";
          return false;
        }
        if (age < country_age) {
          dateInputs.forEach((input) => (input.style.borderColor = "red"));
          const errorMessage = document.getElementById("error-message");
          errorMessage.textContent = "Sorry, you are not of legal drinking age.";
          errorMessage.style.display = "block";
          return false;
        } else {
          const errorMessage = document.getElementById("error-message");
          errorMessage.textContent = "";
          errorMessage.style.display = "none";
          return true;
        }
  
    }
     // Function to handle onblur event and get all input values
  
      const inputs = document.querySelectorAll('.date-input');
  
      // Loop through all input fields and store their values
      inputs.forEach(input => {
        input.addEventListener('change', function(){
          fullvalidation();
        })
      });
  
    document.getElementById("submit-age-verification")
      .addEventListener("click", function () {
        if (fullvalidation()){
           // Function to set a cookie
           function setCookie(name, value, days) {
            let expires = "";
            if (days) {
              let date = new Date();
              date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
              expires = "; expires=" + date.toUTCString();
            }
            document.cookie =
              name + "=" + encodeURIComponent(value) + expires + "; path=/";
          }
  
          // Check the checkbox status and set the cookie accordingly
          function savePreference() {
            const rememberMeChecked =
              document.getElementById("remember-me").checked;
  
            if (rememberMeChecked) {
              // Set cookie for 1 year (365 days)
              setCookie("userPreference", "remembered", 365);
            } else {
              // Set cookie for 1 day
              setCookie("userPreference", "remembered", 1);
            }
          }
          savePreference();
          hidePopup();
        }
        
      });
  
  
  
  const countries = window.theme.countryAndAge.slice(1,-1).split("\n");
  console.log("countries", countries );
  const countryInput = document.getElementById('country-input');
  const suggestionsBox = document.getElementById('suggestions');
  
  // Event listener for input field
  countryInput.addEventListener('input', function () {
    const input = this.value.toLowerCase();
    suggestionsBox.innerHTML = '';  // Clear previous suggestions
    if (input) {
        const filteredCountries = countries.filter(country => country.toLowerCase().includes(input));
        console.log( "filteredCountries", filteredCountries );
        filteredCountries.forEach(country => {
            // Split the country:age value into separate country and age
            const splitData = country.split(":");
            const countryName = splitData[0];  // Extract country name
            const age = splitData[1];  // Extract age value
  
            const div = document.createElement('li');
            div.classList.add('suggestion-item');
            div.textContent = countryName;  // Only show country name in the list
            div.setAttribute('data-country', countryName);  // Store country name
            div.setAttribute('data-age', age);  // Store age value as data attribute
  
            // Add click event to each suggestion
            div.addEventListener('click', function () {
                // When a suggestion is clicked, populate the input field with the selected country and age
                countryInput.value = `${countryName}`; 
                countryInput.setAttribute('data-age', age);  // Format as Country (Age: X)
                suggestionsBox.innerHTML = '';  // Clear the suggestions
                suggestionsBox.style.display = 'none';  // Hide suggestions
                countryInput.style.borderColor = "#000";
                const errorMessage = document.getElementById("error-message");
                errorMessage.textContent = "";
                errorMessage.style.display = "none";
                fullvalidation();
                
            });
  
            suggestionsBox.appendChild(div);  // Append suggestion to the suggestions box
        });
        suggestionsBox.style.display = 'block';  // Show suggestions
    } else {
        suggestionsBox.style.display = 'none';  // Hide suggestions when input is empty
    }
  });
  
  // Hide suggestions when clicking outside the input field or dropdown
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#countryInput')) {
        suggestionsBox.innerHTML = '';  // Clear suggestions
        suggestionsBox.style.display = 'none';  // Hide suggestions
    }
  });
  });
  